import set from 'lodash/set'
import get from 'lodash/get'
import { GET_ALL_TRAINERS } from '~/graphql/queries/academyTrainers'
import { UPDATE_TRAINER, CREATE_TRAINER, REMOVE_TRAINERS } from '~/graphql/mutations/trainer'
import defaultUserAvatar from '~/assets/images/default-avatar.png'
import { checkUrlImage } from '~/utils/file'

const actionTypes = {
  GET_ALL_TRAINERS: 'GET_ALL_TRAINERS',
  UPDATE_TRAINER: 'UPDATE_TRAINER',
  CREATE_TRAINER: 'CREATE_TRAINER',
  REMOVE_TRAINERS: 'REMOVE_TRAINERS',
}

const mutationTypes = {
  SET_FETCHING_ALL_TRAINERS: 'SET_FETCHING_ALL_TRAINERS',
  SET_ALL_TRAINERS: 'SET_ALL_TRAINERS',
  SET_TOTAL_TRAINERS: 'SET_TOTAL_TRAINERS',
  SET_UPDATING: 'SET_UPDATING',
  SET_CREATING: 'SET_CREATING',
  SET_DELETING: 'SET_DELETING',
  SET_TRAINER_INFO: 'SET_TRAINER_INFO',
  SET_TRAINERS_AFTER_DELETED: 'SET_TRAINERS_AFTER_DELETED',
}

export const state = () => ({
  creating: false,
  updating: false,
  deleting: false,
  fetchingAll: true,
  allTrainers: [],
  totalTrainers: null,
})

export const mutations = {
  [mutationTypes.SET_ALL_TRAINERS](state, allTrainers) {
    state.allTrainers = allTrainers
  },
  [mutationTypes.SET_TRAINER_INFO](state, info) {
    const found = state.allTrainers.findIndex((trainer) => trainer.id === info.id)
    found !== -1 && set(state.allTrainers, found, info)
  },
  [mutationTypes.SET_TRAINERS_AFTER_DELETED](state, ids) {
    state.allTrainers = state.allTrainers.filter((trainer) => !ids.includes(trainer.id))
  },
  [mutationTypes.SET_FETCHING_ALL_TRAINERS](state, fetchingAll) {
    state.fetchingAll = fetchingAll
  },
  [mutationTypes.SET_TOTAL_TRAINERS](state, totalTrainers) {
    state.totalTrainers = totalTrainers
  },
  [mutationTypes.SET_UPDATING](state, updating) {
    state.updating = updating
  },
  [mutationTypes.SET_CREATING](state, creating) {
    state.creating = creating
  },
  [mutationTypes.SET_DELETING](state, deleting) {
    state.deleting = deleting
  },
}

export const actions = {
  async [actionTypes.UPDATE_TRAINER]({ commit }, params) {
    commit(mutationTypes.SET_UPDATING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: UPDATE_TRAINER,
        variables: {
          ...params,
        },
      })
      if (data && data.academyUpdateTrainer) {
        commit(mutationTypes.SET_TRAINER_INFO, data.academyUpdateTrainer)
      }
      commit(mutationTypes.SET_UPDATING, false)
      return { data, success: true }
    } catch (error) {
      return { error, success: false }
    }
  },
  async [actionTypes.CREATE_TRAINER]({ commit, state }, trainer) {
    commit(mutationTypes.SET_CREATING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: CREATE_TRAINER,
        variables: trainer,
      })
      if (data && data.academyCreateTrainer) {
        const allTrainers = [data.academyCreateTrainer].concat(state.allTrainers)
        commit(mutationTypes.SET_ALL_TRAINERS, allTrainers)
      }
      commit(mutationTypes.SET_CREATING, false)
      return { data, success: true }
    } catch (error) {
      return { error, success: false }
    }
  },
  async [actionTypes.REMOVE_TRAINERS]({ commit }, ids) {
    commit(mutationTypes.SET_DELETING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const { data } = await apolloClient.mutate({
        mutation: REMOVE_TRAINERS,
        variables: {
          trainerIds: ids,
        },
      })
      if (data && data.academyRemoveTrainers) {
        commit(mutationTypes.SET_TRAINERS_AFTER_DELETED, ids)
      }
      commit(mutationTypes.SET_DELETING, false)
      return { data, success: true }
    } catch (error) {
      return { error, success: false }
    }
  },
  async [actionTypes.GET_ALL_TRAINERS]({ commit, rootState }, params) {
    commit(mutationTypes.SET_FETCHING_ALL_TRAINERS, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      const queries = params || {
        schoolId: rootState.school.schoolProfile.id,
        limit: 10,
        search: '',
      }
      const { data } = await apolloClient.query({
        query: GET_ALL_TRAINERS,
        fetchPolicy: 'no-cache',
        variables: { ...queries },
      })
      for (let index = 0; index < data.academyTrainers.data.length; index++) {
        const trainer = data.academyTrainers.data[index]
        if (get(trainer, 'media.url', '')) {
          try {
            await checkUrlImage(trainer.media.url)
          } catch (error) {
            set(trainer.media, 'url', defaultUserAvatar)
          }
        }
      }
      commit(mutationTypes.SET_ALL_TRAINERS, data.academyTrainers.data)
      commit(mutationTypes.SET_TOTAL_TRAINERS, data.academyTrainers.meta.total)
      commit(mutationTypes.SET_FETCHING_ALL_TRAINERS, false)
      return { data, success: true }
    } catch (error) {
      console.error('GET_ALL_TRAINERS', error)
      return { error, success: false }
    }
  },
}

export const getters = {
  fetchingAll: (state) => state.fetchingAll,
  allTrainers: (state) => state.allTrainers,
  totalTrainers: (state) => state.totalTrainers,
}
